import Route from 'cio/routes/base';
import TransactionalMessageSetupReviewController from 'cio/pods/transactional/message/setup/review/controller';
import TransactionalMessageModel from 'cio/models/transactional-message';
import Transition from '@ember/routing/-private/transition';

export default class TransactionalMessageSetupReview extends Route {
  crumb() {
    return {
      name: 'Send Message',
      path: this.routeName,
    };
  }

  setupController(
    controller: TransactionalMessageSetupReviewController,
    model: TransactionalMessageModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.setDefaults();
  }
}
